module.exports = {
  giftingComponentEvents: {
    GiftingOccasions: {
      code: 'GiftingOccasions',
      events: {
        PageLoaded: {
          description:
            'Triggered when the "Select an occasion" page is viewed.',
          eventHub: {
            code: 'PageLoaded',
            action: 'Gifting Occasions_Page Loaded'
          }
        },
        OccasionClicked: {
          description: 'Triggered when a gifting occasion is clicked.',
          eventHub: {
            code: 'OccasionClicked',
            action: 'Gifting Occasions_[$.occasion] Clicked'
          }
        },
        CtaClicked: {
          description: 'Triggered when the CTA button is clicked.',
          eventHub: {
            code: 'CtaClicked',
            action: 'Gifting Occasions_Continue Clicked'
          }
        }
      }
    },
    GiftingAmount: {
      code: 'GiftAmount',
      events: {
        PageLoaded: {
          description: 'Triggered when the "Gift amount" page is viewed.',
          eventHub: {
            code: 'PageLoaded',
            action: 'Gifting Occasions_Page Loaded',
            dataKeys: ['occasion']
          }
        },
        AmountClicked: {
          description:
            'Triggered when a predefined gifting amount option is clicked.',
          eventHub: {
            code: 'AmountClicked',
            action: 'Gifting Occasions_[$.amount] Clicked'
          }
        },
        CustomClicked: {
          description: 'Triggered after a gifting custom amount is entered.',
          eventHub: {
            code: 'CustomClicked',
            action: 'Gifting Occasions_Custom Clicked',
            dataKeys: ['amount']
          }
        },
        CtaClicked: {
          description: 'Triggered when the CTA button is clicked.',
          eventHub: {
            code: 'CtaClicked',
            action: 'Gift Amount_Continue Clicked'
          }
        }
      }
    },
    GiftingRelationship: {
      code: 'Relationship',
      events: {
        PageLoaded: {
          description:
            'Triggered when the "We need a few details" page is viewed.',
          eventHub: {
            code: 'PageLoaded',
            action: 'Relationship_Page Loaded'
          }
        },
        RelationshipSelected: {
          description:
            'Triggered when a relationship to the child option is selected.',
          eventHub: {
            code: 'RelationshipSelected',
            action: 'Relationship_Relationship Selected'
          }
        },
        CtaClicked: {
          description: 'Triggered when the CTA button is clicked.',
          eventHub: {
            code: 'CtaClicked',
            action: 'Relationship_Continue Clicked',
            dataKeys: ['relationship']
          }
        }
      }
    },
    GiftingReview: {
      code: 'Review',
      events: {
        PageLoaded: {
          description:
            "Triggered when the 'Let's quickly review' page is viewed.",
          eventHub: {
            code: 'PageLoaded',
            action: 'Review_Page Loaded'
          }
        },
        CtaClicked: {
          description: 'Triggered when the CTA button is clicked.',
          eventHub: {
            code: 'CtaClicked',
            action: 'Review_Pay and send gift Clicked'
          }
        }
      }
    },
    GiftingSuccess: {
      code: 'SuccessPage',
      events: {
        PageLoaded: {
          description: 'Triggered when the Gifting success page is viewed.',
          eventHub: {
            code: 'PageLoaded',
            action: 'Success Page_Page Loaded'
          }
        },
        CtaClicked: {
          description: 'Triggered when the CTA button is clicked.',
          eventHub: {
            code: 'CtaClicked',
            action: 'Success Page_Done Clicked'
          }
        }
      }
    }
  }
};
